/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import confirmationMessages from '../../../shared/models/Enum/AchConfirmationMessages';

@Component({
  selector: 'deposit-funds-receipt',
  template: require('./deposit-funds-receipt.component.html')
})

export class DepositFundsReceiptComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.confirmationMessages = confirmationMessages;
    this.frequency = this.appActions.getData('DepositFunds.frequency');
    this.isAfterHours = this.appActions.getData('DepositFunds.isAfterHours');

    if (this.frequency !== 'ONE_TIME') {
      this.form.inputs.confirmationHelper.text = confirmationMessages.get('OAT_RECURRING');
    } else if (this.flowManager.isOneAllyBank && this.frequency === 'ONE_TIME') {
      if (this.isAfterHours) {
        this.form.inputs.confirmationHelper.text = this.confirmationMessages.get('OAT_AFTER_355');
      } else {
        this.form.inputs.confirmationHelper.text = this.confirmationMessages.get('OAT_NONRECURRING');
      }
    } else {
      if (this.isAfterHours) {
        this.form.inputs.confirmationHelper.text = this.confirmationMessages.get('ACH_AFTER_255');
      } else {
        this.form.inputs.confirmationHelper.text = this.confirmationMessages.get('ACH');
      }
    }
    this.flowManager.fundingMethod = this.flowManager.isOneAllyBank ? 'OAT' : 'ACH';
  }

  ngOnInit() {
    this.appActions.setData('StepCompleted.achTransfer', true);
    const contributionYear = this.form.inputs.contributionYear;

    if (this.flowManager.isIra) {
      contributionYear.showUp = true;
    }

    if (this.flowManager.isAuthed) {
      this.form.buttons.inputs.next.text = 'Go to Accounts';
    } else {
      this.form.buttons.inputs.next.text = 'Next';
    }

    this.flowManager.hasFundedAccount = true;
  }

  btnClick(e) {
    if (e.action === 'next') {
      //authed
      if (this.flowManager.isAuthed) {
        this.flowManager.ssoToAlly();
        //sso to consolidated dash
      }
      //not authed
      else {
        this.router.navigate(['/credentials']);
        //to create user step
      }
    }
  }
}
